<template>
  <div class="pb-editor">
    <div class="pb-editor-panels">
      <RouterView
        :name="routeViews.LeftPanel"
        class="pb-left-panel"
      />
      <RouterView
        :name="routeViews.MiddlePanel"
        class="pb-middle-panel"
      />
      <RouterView
        :name="routeViews.RightPanel"
        class="pb-right-panel"
      />
    </div>
  </div>
  <RouterView :name="routeViews.MainDialog" />
</template>

<script setup>
import routeViews from '@/router/views'

/*
TODO: add transition to Dialog RouterView once this gets fixed
https://github.com/vuejs/core/issues/5836
 */
</script>

<style lang="scss" src="./ProfileContent.scss"></style>
